var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlanSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.056,
    height: 34.457,
    viewBox: "0 0 31.056 34.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-11 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.467 0v10.584a1.411 1.411 0 0 1-1.411 1.411H0",
    className: "cls-1",
    transform: "translate(19.756 17.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M0 16.934V1.411A1.411 1.411 0 0 1 1.411 0h11.995",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(4.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M18.345 2.822H8.467a1.411 1.411 0 0 1-1.129-.564L6.068.564A1.411 1.411 0 0 0 4.939 0H1.411A1.411 1.411 0 0 0 0 1.411v12.7a1.411 1.411 0 0 0 1.411 1.411h16.934a1.411 1.411 0 0 0 1.411-1.411V4.233a1.411 1.411 0 0 0-1.411-1.411z",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(0 16.934)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.528,
    cy: 3.528,
    r: 3.528,
    className: "cls-1",
    transform: "translate(19.756 2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    d: "M0 3a6.35 6.35 0 0 1 10.79 0",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(17.889 10.582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanSmall);
export default __webpack_public_path__ + "static/media/icon-plan-small.845ede60846fb8ae5da3fbc8d4c2e7ec.svg";
export { ForwardRef as ReactComponent };